/**
 * Which address format a data-collection step should collect.
 *
 * Routes flag this on their settings (`isUKAddress` / `isDeAddress`, in a
 * couple of historical spellings) at either the journey level or the
 * matched route step. Returns "de", "uk" or "us" (the default).
 */
export const ADDRESS_REGION_US = "us";
export const ADDRESS_REGION_UK = "uk";
export const ADDRESS_REGION_DE = "de";

const truthy = (...values) => values.some(Boolean);

export function getAddressRegion(settings, componentKey) {
  const journeySettings = settings?.journey?.settings || {};
  const matchedRoute =
    settings?.journey?.route?.find((route) => route.path === componentKey) ||
    {};
  const routeSettings = matchedRoute.settings || {};

  if (
    truthy(
      journeySettings.isDeAddress,
      journeySettings.isDEAddress,
      routeSettings.isDeAddress,
      routeSettings.isDEAddress,
      matchedRoute.isDeAddress,
      matchedRoute.isDEAddress,
    )
  ) {
    return ADDRESS_REGION_DE;
  }

  if (
    truthy(
      journeySettings.isUKAddress,
      journeySettings.isUkAddress,
      routeSettings.isUKAddress,
      routeSettings.isUkAddress,
      matchedRoute.isUKAddress,
      matchedRoute.isUkAddress,
    )
  ) {
    return ADDRESS_REGION_UK;
  }

  return ADDRESS_REGION_US;
}

/** UK and DE both write dates day-first (DD/MM/YYYY). */
export function isDayFirstRegion(region) {
  return region === ADDRESS_REGION_UK || region === ADDRESS_REGION_DE;
}
